module.exports = __webpack_public_path__ + "static/media/success.b9448cde.svg";